import React from 'react';
import { Collapse, Grid } from '@mui/material';

import {
  TextField,
  Checkboxes,
  Switches,
  Typography,
  Paper,
  CardContent,
  CardHeader,
  BoltIconOutlinedMUI,
  IconAvatar,
} from '@occc-app/design-system';
import { parseNumber } from '@occc-app/lib/finalFormUtils';

import { RequiresActivationConstraintFormValues } from './types';

type RequiresActivationConstraintProps = {
  children?: React.ReactNode;
  values: RequiresActivationConstraintFormValues;
  activationFieldName?: string;
};

export const RequiresActivationConstraint = ({
  values,
  children,
  activationFieldName = 'activation',
}: RequiresActivationConstraintProps) => (
  <Paper>
    <CardHeader
      title={<Typography variant='subtitle1'>Require Activation</Typography>}
      subheader={
        <Typography variant='body2' color='textSecondary'>
          Members must activate the offer before redeeming it
        </Typography>
      }
      action={<Switches name={`${activationFieldName}.isEnabled`} data={{}} />}
      avatar={<IconAvatar Icon={BoltIconOutlinedMUI as any} />}
      sx={{ py: 2, px: 3 }}
    />
    <Collapse in={values?.isEnabled} timeout='auto' unmountOnExit>
      <CardContent sx={{ pt: 0 }}>
        <Grid container spacing={2} alignItems='center' mb={2}>
          <Grid item>
            <Checkboxes
              name={`${activationFieldName}.requiresActivation.isMustFulfillWithinEnabled`}
              data={{ label: 'Member must fulfill within', value: false }}
            />
          </Grid>
          <Grid item>
            <Checkboxes
              name={`${activationFieldName}.requiresActivation.allowMultipleFulfillmentsOnActivation`}
              data={{
                label: 'Members can fulfill multiple times without reactivation',
                value: false,
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              name={`${activationFieldName}.requiresActivation.mustFulfillWithinDays`}
              label='Days'
              fieldProps={{
                parse: (value) => parseNumber(value as string),
              }}
              disabled={!values?.requiresActivation?.isMustFulfillWithinEnabled}
            />
          </Grid>
        </Grid>
        {children}
      </CardContent>
    </Collapse>
  </Paper>
);
